var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg043Worker = function Svg043Worker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 271h90v150H91z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V181H0zm241-271h210v30H241zm180 60v30h-30v-30zm-60 0v30h-30v-30zm-60 0v30h-30v-30zm-60 60h210v30H241zm0 60h210v30H241zM61 241h150v210H61zM226 0h60v151h-60z"
  })));
};
export default Svg043Worker;